import React, { useEffect, useState } from 'react'
import { Form, Input, Button, message, Checkbox } from 'antd'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { contexts } from '@/domains'
import { Storage } from '@/utils/Storage'
import TianaiCaptchaModal from '@/components/TianaiCaptchaModal/TianaiCaptchaModal'
import { LoginAgreementLinks } from './LoginAgreementConfig'
import { LoginFormConfig } from './LoginConfig'
import '@/styles/pages/login.less'

const { GlobalContext } = contexts

const titleRowJustifyContent = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as const

const loginFormStyle = {
  '--login-form-width': `${LoginFormConfig.widthPx}px`,
  '--login-form-padding-top': `${LoginFormConfig.paddingTopPx}px`,
  '--login-form-padding-horizontal': `${LoginFormConfig.paddingHorizontalPx}px`,
  '--login-submit-button-bottom-gap': `${LoginFormConfig.submitButtonBottomGapPx}px`,
  '--login-title-logo-size': `${LoginFormConfig.titleLogoSizePx}px`,
  '--login-title-row-gap': `${LoginFormConfig.titleRowGapPx}px`,
  '--login-title-row-margin-bottom': `${LoginFormConfig.titleRowMarginBottomPx}px`,
  '--login-title-row-justify': titleRowJustifyContent[LoginFormConfig.titleRowAlign],
  '--login-title-text-align': LoginFormConfig.titleRowAlign,
  '--login-title-font-size': `${LoginFormConfig.titleFontSizePx}px`,
  '--login-tip-font-size': `${LoginFormConfig.tipFontSizePx}px`,
  '--login-tip-margin-bottom': `${LoginFormConfig.tipMarginBottomPx}px`,
  '--login-form-item-margin-bottom': `${LoginFormConfig.formItemMarginBottomPx}px`,
  '--login-input-height': `${LoginFormConfig.inputHeightPx}px`,
  '--login-submit-button-height': `${LoginFormConfig.submitButtonHeightPx}px`,
  '--login-submit-button-font-size': `${LoginFormConfig.submitButtonFontSizePx}px`,
  '--login-agreement-font-size': `${LoginFormConfig.agreementFontSizePx}px`,
} as React.CSSProperties

const Login = () => {
  const { login, getVerificationCode } = GlobalContext.useContainer()
  const [captchaVisible, setCaptchaVisible] = useState(false)
  const store = useLocalObservable(() => ({
    phone: ''
  }))
  useEffect(() => {
    void Storage.removeItem('token')
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('teamId')
    localStorage.removeItem('teamMap')
  }, [])

  const onFinish = async (values: any) => {
    const res = await login({ phone: values.phone, code: values.code })
    if (res) {
      message.success('登录成功')
      const hasTeam = res.userDTO?.teamList && res.userDTO.teamList.length > 0
      window.location.hash = hasTeam ? '#/home' : '#/join'
    }
  }

  const handleSendClick = () => {
    if (store.phone.length < 11) {
      message.error('请输入正确的手机号')
      return
    }
    setCaptchaVisible(true)
  }

  const handleCaptchaSuccess = async (captchaToken: string) => {
    const sent = await getVerificationCode({ phone: store.phone, captchaToken })
    if (sent) {
      message.success('验证码发送成功, 请注意查收')
    }
  }

  return (
    <div className="sparrow-wrap login">
      <div className="login-form" style={loginFormStyle}>
        <div className="login-title-row">
          <span className="login-title-logo" aria-hidden />
          <h2>先进组织先远程，先进远程用麻雀</h2>
        </div>
        <span>未注册的手机号验证后将自动创建账号</span>
        <Form onFinish={onFinish}>
          <Form.Item
            className="login-form-item"
            label=""
            name="phone"
            rules={[{ required: true, message: '请输入你的手机号' }]}
          >
            <Input
              className="login-input"
              prefix="+86"
              onChange={(e) => {
                store.phone = e.target.value
              }}
              placeholder="请输入手机号"
            />
          </Form.Item>

          <Form.Item
            className="login-form-item"
            label=""
            name="code"
            rules={[{ required: true, message: '请输入短信验证码' }]}
          >
            <Input
              className="login-input"
              suffix={
                <Button
                  type="text"
                  className="login-send-code-btn"
                  onClick={handleSendClick}
                >
                  发送
                </Button>
              }
              placeholder="验证码"
            />
          </Form.Item>
          <Form.Item className="login-form-item" label="" name="checkbox">
            <Checkbox className="login-checkbox" checked={true}>
              <span className="login-agreement-text">
                我已阅读并同意
                {LoginAgreementLinks.map((item, index) => (
                  <React.Fragment key={item.label}>
                    {index > 0 ? '、' : null}
                    <a
                      className="login-agreement-link"
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item.label}
                    </a>
                  </React.Fragment>
                ))}
              </span>
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Button
              className="login-form-button"
              type="primary"
              htmlType="submit"
            >
              登录/注册
            </Button>
          </Form.Item>
        </Form>
      </div>
      <TianaiCaptchaModal
        visible={captchaVisible}
        onClose={() => setCaptchaVisible(false)}
        onSuccess={handleCaptchaSuccess}
      />
    </div>
  )
}

export default observer(Login)
